export default __webpack_public_path__ + "static/studio-slider-2-33054e1b51464a3c040f6198b2d7780b.png";